let text = "The Difference is Endless - ";
let offset = 0;
let intervalId;
let originalTitle = document.title; // Store the original page title

function scrollTitle() {
	document.title = text.substring(offset) + text.substring(0, offset);
	offset = (offset + 1) % text.length;
}

function handleVisibilityChange() {
	if (document.hidden) {
		intervalId = setInterval(scrollTitle, 100);
	} else {
		clearInterval(intervalId);
		document.title = originalTitle; // Set it back to the original title when the tab is active
	}
}

document.addEventListener("visibilitychange", handleVisibilityChange);

// Start the interval when the page is loaded, in case it starts in a hidden state
if (document.hidden) {
	intervalId = setInterval(scrollTitle, 100);
}

/*
 * *********************************************************************************************************************************************
 * https://allinworld99.blogspot.com/2015/12/how-to-animate-blogger-or-website-in.html
 */
// let text = "The Difference is Endless - ";
// let offset = 0;
// let intervalId;

// function scrollTitle() {
// 	document.title = text.substring(offset, text.length) + text.substring(0, offset);
// 	offset++;

// 	if (offset > text.length) offset = 0;

// 	window.setTimeout("scrolltitle()", 100);
// }

// function handleVisibilityChange() {
// 	if (document.hidden) {
// 		intervalId = setInterval(scrollTitle, 100);
// 	} else {
// 		clearInterval(intervalId);
// 		document.title = "The Difference is Endless"; // Set it to the default title when the tab is active
// 	}
// }

// document.addEventListener("visibilitychange", handleVisibilityChange);

// // Start the interval when the page is loaded, in case it starts in a hidden state
// if (document.hidden) {
// 	intervalId = setInterval(scrollTitle, 100);
// }

// // msg = document.title;
// msg = "The Difference is Endless";
// msg = msg + " - ";
// position = 0;

// function scrolltitle() {
// 	if (document.hidden) {
// 		document.title = msg.substring(position, msg.length) + msg.substring(0, position);
// 		position++;

// 		if (position > msg.length) position = 0;
// 		window.setTimeout("scrolltitle()", 50);
// 	} else {
// 		document.title = "The Difference is Endless";
// 	}
// }

// scrolltitle();

/*
 * *********************************************************************************************************************************************
 * https://stackoverflow.com/questions/46921499/how-do-i-animate-title-of-site-in-browser-tab
 */
// function recursiveAnimateTitle(string) {
// 	let firstLetter = string[0];
// 	let title = document.querySelector("title");
// 	title.innerHTML += firstLetter;
// 	if (string.length > 1) {
// 		setTimeout(function () {
// 			recursiveAnimateTitle(string.substring(1));
// 		}, 100);
// 	}
// }

// function animateTitle(string) {
// 	document.querySelector("title").innerHTML = "";
// 	recursiveAnimateTitle(string);
// }

// animateTitle("The Difference is Endless");

/*
 * *********************************************************************************************************************************************
 * https://gist.github.com/mbohanon/def685be086a44b833d37fe0cccf17c9
 */
// Here's an eye catching example to get your visitors back when your web page tab is not active within the browser (onblur).
// This script will animate the original title text with an intro, the original title text is restored when the tab is returned to active state (focus).
// When the tab is clicked the original page title is restored.
// For social media sharing it is highly recommended to include the original page title text with the prefaced animated text (onblur).
//Created by SHEmedia.us
// $(function () {
// 	var origTitle, animatedTitle, timer;

// 	function animateTitle(newTitle) {
// 		var currentState = false;
// 		origTitle = document.title; // save original title
// 		animatedTitle = "The Difference is Endless" + origTitle;
// 		timer = setInterval(startAnimation, 2000);

// 		function startAnimation() {
// 			// animate between the original and the new title
// 			document.title = currentState ? origTitle : animatedTitle;
// 			currentState = !currentState;
// 		}
// 	}

// 	function restoreTitle() {
// 		clearInterval(timer);
// 		document.title = origTitle; // restore original title
// 	}

// 	// Change page title on blur
// 	$(window).blur(function () {
// 		animateTitle();
// 	});

// 	// Change page title back on focus
// 	$(window).focus(function () {
// 		restoreTitle();
// 	});
// });

/*
 * *********************************************************************************************************************************************
 */
